const SEEN_PREFIX = 'dem-consult-call-seen:';

function seenKey(userId) {
  return `${SEEN_PREFIX}${userId || 'anon'}`;
}

export function readSeenConsultCallIds(userId) {
  if (typeof window === 'undefined') return new Set();
  try {
    const raw = window.sessionStorage.getItem(seenKey(userId));
    const list = raw ? JSON.parse(raw) : [];
    return new Set(Array.isArray(list) ? list.map(String) : []);
  } catch {
    return new Set();
  }
}

export function markConsultCallIdsSeen(userId, ids) {
  if (typeof window === 'undefined') return;
  const next = readSeenConsultCallIds(userId);
  (ids || []).forEach((id) => next.add(String(id)));
  try {
    window.sessionStorage.setItem(seenKey(userId), JSON.stringify([...next]));
  } catch {
    /* ignore quota */
  }
}

let sharedCtx = null;

function getAudioContext() {
  if (typeof window === 'undefined') return null;
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return null;
  if (!sharedCtx) {
    sharedCtx = new Ctx();
    const unlock = () => {
      sharedCtx?.resume?.().catch(() => {});
      window.removeEventListener('click', unlock);
      window.removeEventListener('keydown', unlock);
    };
    window.addEventListener('click', unlock);
    window.addEventListener('keydown', unlock);
  }
  return sharedCtx;
}

/** Короткий двухтональный сигнал в браузере — без файла. */
export function playConsultCallChime() {
  if (typeof window === 'undefined') return;
  try {
    const ctx = getAudioContext();
    if (!ctx) return;
    ctx.resume?.().catch(() => {});
    const now = ctx.currentTime;
    const tones = [
      { at: 0, freq: 880 },
      { at: 0.22, freq: 1175 },
    ];
    tones.forEach(({ at, freq }) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, now + at);
      gain.gain.exponentialRampToValueAtTime(0.14, now + at + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + at + 0.18);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(now + at);
      osc.stop(now + at + 0.2);
    });
  } catch {
    /* autoplay / unsupported */
  }
}
